import React, { useContext, createContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  SidebarContainer,
  SidebarHeader,
  SidebarMenu,
  SidebarGroup,
  SidebarItem,
  SidebarFooter,
  SidebarLink,
  SidebarTitle,
  SidebarAvatar,
  SidebarUserInfo,
  SidebarIcon,
  SidebarText,
  SidebarUserName,
  SidebarUserEmail,
} from "./Sidebar.styles";
import moreVerticalIcon from "../../assets/icons/moreVerticalIcon.svg";
import courseImg from "../../assets/icons/courseImg.svg";
import statsImg from "../../assets/icons/statsImg.svg";
import studentIcon from "../../assets/icons/studentIcon.svg";
import homeworkIcon from "../../assets/icons/homeworkIcon.svg";
import refIcon from "../../assets/icons/refIcon.svg";
import paymentIcon from "../../assets/icons/paymentIcon.svg";
import settingsIcon from "../../assets/icons/settingsIcon.svg";
import helpIcon from "../../assets/icons/helpIcon.svg";
import docTempIcon from "../../assets/icons/docTempIcon.svg";
import leadsIcon from "../../assets/icons/leadsIcon.svg";
import calendarIcon from "../../assets/icons/calendarIcon.svg";
import { useUser } from "../../context/UserContext";

const SidebarContext = createContext({ expanded: true });

export const SidebarMenuProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [expanded] = useState(true);

  return (
    <SidebarContext.Provider value={{ expanded }}>
      {children}
    </SidebarContext.Provider>
  );
};

const SidebarItemComponent: React.FC<{
  icon: string;
  text: string;
  to: string;
}> = ({ icon, text, to }) => {
  const { expanded } = useContext(SidebarContext);
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <SidebarItem>
      <Link to={to}>
        <SidebarLink isActive={isActive}>
          <SidebarIcon src={icon} alt={text} />
          {expanded && <SidebarText>{text}</SidebarText>}
        </SidebarLink>
      </Link>
    </SidebarItem>
  );
};

const Sidebar: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  return (
    <SidebarContainer>
      <SidebarHeader>LISRENT</SidebarHeader>
      <SidebarMenu>
        <SidebarGroup>
          <SidebarTitle>Курсы и статистика</SidebarTitle>
          <SidebarItemComponent icon={courseImg} text="Мои курсы" to="/courses" />
          <SidebarItemComponent icon={statsImg} text="Статистика" to="/statistics" />
        </SidebarGroup>
        <SidebarGroup>
          <SidebarTitle>Учеба</SidebarTitle>
          <SidebarItemComponent icon={leadsIcon} text="Лиды" to="/leads" />
          <SidebarItemComponent icon={studentIcon} text="Ученики" to="/students" />
          <SidebarItemComponent icon={calendarIcon} text="Календарь" to="/events" />
          <SidebarItemComponent
            icon={homeworkIcon}
            text="Домашние задания"
            to="/homework"
          />
        </SidebarGroup>
        <SidebarGroup>
          <SidebarTitle>Оплата и акции</SidebarTitle>
          <SidebarItemComponent icon={refIcon} text="Реферальная программа" to="/referals" />
          <SidebarItemComponent icon={paymentIcon} text="Оплата" to="/payment" />
        </SidebarGroup>
        <SidebarGroup>
          <SidebarTitle>Другое</SidebarTitle>
          <SidebarItemComponent icon={docTempIcon} text="Документы" to="/documents" />
          <SidebarItemComponent icon={helpIcon} text="Поддержка" to="/support-requests" />
          <SidebarItemComponent icon={settingsIcon} text="Настройки" to="/settings" />
        </SidebarGroup>
      </SidebarMenu>
      <SidebarFooter onClick={() => navigate("/profile")}>
        <SidebarAvatar>
          {user
            ? `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
            : "??"}
        </SidebarAvatar>
        <SidebarUserInfo>
          <div>
            <SidebarUserName>
              {user ? `${user.firstName} ${user.lastName}` : "Загрузка..."}
            </SidebarUserName>
            <SidebarUserEmail>
              {user?.email || "Загрузка..."}
            </SidebarUserEmail>
          </div>
          <img src={moreVerticalIcon} alt="Settings" />
        </SidebarUserInfo>
      </SidebarFooter>
    </SidebarContainer>
  );
};

export default Sidebar;

